




















import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
import TiandituPanel from '@/views/search/TiandituPanel.vue';
import BaiduPanel from '@/views/search/BaiduPanel.vue';
@Component({
    name: 'SearchResult',
    components : {
        TiandituPanel,
        BaiduPanel,
    },
    mixins: [MapResolver],
})
export default class SearchResult extends Vue {
    @Injectable() public container!: Container;


    @Prop() public searchResultDatas: any;
    @Prop() public messageDetailData: any;

    /*
* tab标签
* */
    public tabsArr = [
        {
            name: '百度',
            key: 'baidu',
            index: 1,
            componentName: 'baidu-panel',
        },
        {
            name: '天地图',
            key: 'tianditu',
            index: 0,
            componentName: 'tianditu-panel',
        },
    ];

    /*
* 当前激活的tab
* */
    public curTab = this.tabsArr[0];

    private tempSearchResultDatas: any = this.searchResultDatas;
    private   storeNoAroundDatas: any ;
    constructor() {
        super();
    }

    public handleChangeTab(tab: any, index: number) {
        if (tab.key === this.curTab.key) {
            return;
        }
        this.curTab = tab;
        this.loadMap(this.tempSearchResultDatas[this.curTab.key]);
    }

    @Watch('searchResultDatas', {deep: true})
    private getData(val: any) {
        this.tempSearchResultDatas = this.searchResultDatas;

        if (!this.$store.state.searchStore.isShowRoundFlag) {
            this.storeNoAroundDatas = this.tempSearchResultDatas;
        }
        this.loadMap(val[this.curTab.key]);
    }


    @Watch('$store.state.searchStore.refreshMapPointFlag')
    private refreshMapPoint(val: any) {
        if (val) {
            this.tempSearchResultDatas = this.storeNoAroundDatas;
            this.loadMap(this.storeNoAroundDatas[this.curTab.key]);
            this.$store.dispatch('searchStore/refreshMapPointFlagEmit', false);
        }
    }


    private messageDetailDataEmit(val: any) {
        // 发射该条数据到附近信息面板
        this.$emit('messageDetailDataEmit', val);
    }

    private changeSearchResultDataEmit(val: any) {
        this.tempSearchResultDatas = val;
        if (!this.$store.state.searchStore.isShowRoundFlag) {
            this.storeNoAroundDatas = this.tempSearchResultDatas;
        }
        this.loadMap(val[this.curTab.key]);
    }

    private async loadMap(data: any) {
        const component: any = await this.getComponent();
        if (this.$store.state.searchStore.isShowRoundFlag) {
            const location = this.messageDetailData.data.location.x + ',' + this.messageDetailData.data.location.y;
            component.load(data, location, 1000);
        } else {
            component.load(data);
        }
    }


    private getComponent(moduleName: string = 'Search', componentName: string = 'POISearch') {
        const p = new Promise((resolve, reject) => {
            (this as any).resolveMap('map').then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName, componentName);
                resolve(component);
            }).catch(() => { reject('获取地图组件失败'); });
        });
        return p;
    }

}
